import { render, staticRenderFns } from "./OwnRisk.vue?vue&type=template&id=918e59c2&scoped=true"
import script from "./OwnRisk.vue?vue&type=script&lang=js"
export * from "./OwnRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918e59c2",
  null
  
)

export default component.exports